<template>
  <div class="rolemanagetable">
    <el-table :data="tableData"
              style="width: 100%;padding:10px 10px 0 10px;"
              border>
      <el-table-column prop="name"
                       label="角色名">
      </el-table-column>
      <el-table-column prop="type"
                       v-if="false"
                       label="归属用户">
        <template slot-scope="scope">
          <span>{{scope.row.type === 0 ? '内部用户角色' : '外部用户角色'}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="powerNum"
                       label="权限项">
      </el-table-column>

      <el-table-column prop="roleNum"
                       label="用户数">
        <template slot-scope="scope">
          <span style="color: #5b9bd1;cursor: pointer;"
                @click="openDialog(scope.row)">{{scope.row.roleNum}}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作"
                       width="400">
        <template slot-scope="scope">
          <el-button @click="authClick(scope)"
                     style="color:#13aa65;font-weight:bold;font-size:13px;"
                     type="text"
                     class="btn"
                     size="small"><i style="margin-right:3px;"
               class="el-icon-folder-checked"></i>授权</el-button>
          <span style="margin:0 11px;"> | </span>
          <el-button @click="changeClick(scope)"
                     style="color:#185ED3;font-weight:bold;font-size:13px;"
                     type="text"
                     class="btn"
                     size="small"><i style="margin-right:3px;"
               class="el-icon-edit-outline"></i>修改</el-button>
          <span style="margin:0 11px;"> | </span>
          <el-button @click="removeClick(scope)"
                     style="color:#FF4545;font-weight:bold;font-size:13px;"
                     type="text"
                     class="btn"
                     size="small"><i style="margin-right:3px;"
               class="el-icon-delete"></i>删除</el-button>
        </template>
      </el-table-column>

    </el-table>
    <mydialog @dialogSubmit="dialogSubmit"
              :title="title"
              @changeSubmit="changeSubmit"
              :myform="myform"
              :label="label"
              :dialogFormVisible="dialogFormVisible"></mydialog>

    <el-dialog :visible.sync="dialogVisible"
               width="38%"
               :before-close="handleClose">
      <div slot="title"
           class="header-title"
           :style="{'padding':'15px 20px','box-sizing':'border-box','backgroundColor': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'}">
        <div>查看用户列表</div>
      </div>
      <el-table ref="multipleTable"
                @selection-change="handleSelectionChange"
                :data="rolePerson"
                style="width: 100%;padding:10px 10px 0 10px;margin-bottom:20px;height:300px;overflow-y: auto;"
                border>
        <el-table-column type="selection"
                         width="40">
        </el-table-column>
        <el-table-column prop="userInfo.name"
                         label="姓名"
                         width="100"></el-table-column>
        <el-table-column prop="userInfo.mobile"
                         label="电话"></el-table-column>
        <el-table-column prop="userInfo.email"
                         label="邮箱"></el-table-column>
      </el-table>
      <!-- <div style="position: absolute; right:10px;bottom:75px;">
        <el-pagination @size-change="handleSizeChange"
                         @current-change="handleCurrentChange"
                         :current-page.sync="page"
                         :page-size="pageSize"
                         layout="prev, pager, next"
                         :total="total">
        </el-pagination>
      </div> -->

      <span slot="footer"
            class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary"
                   @click="deleteRolePerson"
                   :style="isSimple?'background-color:#fd9112;border:1px solid #fd9112;':''">移除用户</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { dialog } from '@/components/index'
import { mapActions } from 'vuex'
import { getAuthRole, getPowers, getAuthRoleAccess, deleteAuthRoleAccess } from "@/api/authRole";
export default {
  name: 'rolemanagetable',
  props: {
    tableData: Array,

  },
  components: {
    'mydialog': dialog
  },
  watch: {
    '$store.state.user.dialogFormVisible' (data) {
      this.dialogFormVisible = data
    },
    'myform' (data) {
      this.myform = data
    },
  },
  data () {
    return {
      dialogVisible: false,
      label: ['图库名称', '排序'],
      title: '修改图库',
      myform: {},
      dialogFormVisible: this.$store.state.user.dialogFormVisible,
      dataIndex: 0,  //需要改变table的索引
      mytableData: [],
      rolePerson: [],
      chooseRolePerson: [],
      total: 0,
      roleId: 0,
      page: 0,
      pageSize: 6
      // tableData:[
      //   {
      //     role:'超级管理员',
      //     user:'1名',
      //     power:'125项'
      //   },
      //   {
      //     role:'主编',
      //     user:'6名',
      //     power:'125项'
      //   },
      //   {
      //     role:'记者',
      //     user:'147名',
      //     power:'125项'
      //   }

      // ]
    }
  },
  methods: {
    ...mapActions(["setDialogFormVisible"]),
    authClick (scope) {
      this.$emit('authClick', scope)
    },
    changeClick (scope) {
      this.title = '修改角色'
      this.label = ['角色名称', '排序']
      this.getAuthRoleAsync(scope.row.id)

      // this.$emit('changeClick',scope)
    },
    removeClick (scope) {
      this.$emit('removeClick', scope)
    },
    changeSubmit (data) {
      this.$message.error('修改失败！')
      // console.log(data);
      // let updateMsg = {
      //   name: data.one,
      //   id: data.id,
      //   sort: data.two,
      //   createAt: data.createAt,
      //   status: data.status
      // };
      // this.updateLibAsync(updateMsg);
    },
    //接受dialog组件提交之后传递过来的值
    dialogSubmit (data) {
      this.$emit('formSubmit', data)
    },

    //查询角色
    async getAuthRoleAsync (val) {
      let { status, data, message, errors } = await getAuthRole(val);
      if (status) {
        this.myform = {
          one: data.name,
          two: data.sort,
          ...data
        }
        this.setDialogFormVisible(true)
      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
      }
    },

    openDialog (data) {
      this.roleId = data.id
      this.rolePerson = data.rolePerson
      this.rolePerson = this.rolePerson.filter(item => item.userInfo !== null)
      this.dialogVisible = true
      // this.getAuthRoleAccessAsync({roleId:this.roleId,pageSize: this.pageSize})
    },

    //分页事件
    handleSizeChange (val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange (val) {
      this.page = val
      let data = { roleId: this.roleId, page: this.page, pageSize: this.pageSize }
      // console.log(data)
      // this.getAuthRoleAccessAsync(data)
    },
    handleClose () {
      this.dialogVisible = false
      this.rolePerson = []
      this.chooseRolePerson = []
    },

    deleteRolePerson () {
      if (this.chooseRolePerson.length <= 0) {
        this.$message.warning('请选择用户！')
        return false;
      }
      this.$confirm("确定移除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        confirmButtonClass:this.isCustom ? this.custom == 'xugong' ? 'xgfirm' : 'wcfirm' :this.isSimple ? 'mySimplePriConfirm' : 'myPriConfirm',//点击删除
      })
        .then(async () => {
          let successLength = 0
          for (let i = 0; i < this.chooseRolePerson.length; i++) {
            let roledata = {
              roleId: this.chooseRolePerson[i].roleId,
              userId: this.chooseRolePerson[i].uid,
            }

            let deInfo = await deleteAuthRoleAccess(roledata)

            if (deInfo.status) {
              successLength++
            }
          }

          if (successLength == this.chooseRolePerson.length) {
            this.$message.success('移除成功！')
            this.dialogVisible = false
            this.rolePerson = []
            this.chooseRolePerson = []
          } else {
            this.$message.warning(`有${this.chooseRolePerson.length - successLength}个用户移除失败！`)
            this.dialogVisible = false
            this.rolePerson = []
            this.chooseRolePerson = []
          }


          this.$emit('refreshCom')
        })
        .catch(() => {
          // this.$message({
          //   type: "info",
          //   message: "已取消"
          // });
        });

    },

    handleSelectionChange (val) {
      this.chooseRolePerson = val;
    },


  },

  created () {

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.table {
  width: auto;
}
.btn:hover {
  text-decoration: underline;
}

/* .el-table /deep/ .el-checkbox__inner{
  background-color: #3CB035;
  border-color: #3CB035;
} */
.el-table /deep/ .el-checkbox__input.is-checked + .el-checkbox__label {
  color: #606266;
}
.el-table /deep/ .el-checkbox__input.is-checked .el-checkbox__inner,
.el-table /deep/ .el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #3cb035;
  border-color: #3cb035;
}
</style>
